


// SERVIZI REST
 let basePath = process.env.REST_PATH
 let apiPath =process.env.API_REST_PATH

// servizi esposti dal jar  portale-utils
export const PATH_INIT=basePath+apiPath+"/initLight"
//export const PATH_INFO_USER="/infouser"   usando il compomente UserInfoStore from '@sogei/agenzia-entrate-common' il path è scolpito

export const PATH_MENU_LEFT_PROFILO=basePath+apiPath+"/menu/leftmenu"


//


export const PATH_PORTALE="/PortaleWeb"

//LABEL
export const UTENTE_CONNESSO="Utente connesso"

//COOKIE
export const X_SIAM="x-siam"
export const X_APPL="x-appl"

